import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

const legacySurveyCreateSearchSchema = z.object({
    organizationId: z.string().optional(),
    mode: z.enum(['live', 'sandbox']).optional(),
});

// Surveys moved to the top-level /surveys product area. Keep this route as a
// redirect so old links and bookmarks still work, carrying their deep-link
// organization and mode across.
export const Route = createFileRoute('/_app/(main)/outreaches/survey/create')({
    validateSearch: legacySurveyCreateSearchSchema,
    beforeLoad: ({ search }) => {
        throw redirect({ to: '/surveys/create', search, replace: true });
    },
});
